import React from "react";
import numericFunction from "../../../utils/NumericFunction";
import { formatToPersianAddComma } from "../../../utils/CommaSeparator";

const PrintType7Footer2 = ({ data }) => {
  return (
    <div className={"footerPrintType7"}>
      <div
        className={
          "row2 d-flex justify-content-start pe-3 py-1 align-items-center"
        }
      >
        {data}
      </div>
    </div>
  );
};

export default PrintType7Footer2;
